var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _radialGradient, _path11, _path12, _path13, _path14, _path15, _path16, _radialGradient2, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamping(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.35 80c-14.98-.52-58 3.66-58 19.16s32.75 24.91 60.61 25.08c27.87.17 55.56-9.06 56.61-24.56c1.04-15.5-44.24-19.16-59.22-19.68z",
    fill: "#89af50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.02 25.24c-1.65-.14-2.37 1.84-3.47 3.35c-1.37 1.89-3.23 4.54-4.47 5.3c-1.24.76-3.29 1.85-3.02 3.63c.28 1.79 3.57 2.63 3.57 2.63l-.83 2.82l-4.33 6.6L42.6 64.7l53.17 10.52s14.82-5.41 16.44-7.22c1.17-1.31 1.38-2.34.62-4.13c-1.09-2.57-2.68-4.41-4.4-6.96c-1.6-2.37-3.59-5.5-3.59-5.5l1.53-3.25s1.45-1.98 1.24-3.97c-.26-2.48-1.72-3.88-3.16-6.15c-1.44-2.27-3.99-6.18-3.99-6.18L99 28.87s4.74-.74 4.39-2.6c-.34-1.86-1.78-2.91-2.6-3.94c-.83-1.03-4.4-5.78-5.92-7.98c-1.51-2.2-3.56-5.11-5.09-5.16c-1.64-.05-2.84 2-4.49 4.55s-3.12 4.83-5.03 6.5c-3.1 2.71-6.48 6.04-5 7.64c1.61 1.73 3.99 4.7 3.99 4.7l-1.51 2.22s-1.81 2.48-3.37 4.24c-1.29 1.46-2.75 3.23-2.75 3.23l-3.3-1.24s4.62-3.15 4.75-4.13c.14-1.09.02-2.23-2.75-3.51c-2.57-1.19-4.55-4.32-5.38-5.49c-.83-1.15-1.61-2.55-2.92-2.66z",
    fill: "#4da852"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.56 30.13c3.27-.26 3.83-2.63 7.23-3.81c3.06-1.06 4.64.02 4.64.02s.28 1.02-.75 2.34c-.62.79-1.6 1.35-1.79 2.26c-.19.9.1 1.81.1 1.81s-4.33 4.33-8.75 4.33s-4.16-2.18-8.42-2.9c-3.38-.57-6.85 1.71-6.85 1.71s.71-2.26.55-3.32c-.42-2.78-2.24-4.68-2.24-4.68s2.4-1.46 5.92-.99s7.36 3.46 10.36 3.23z",
    fill: "#367c2d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.64 39.64c3.78.05 3.14-1.95 5.95-2.66c2.39-.61 4.5-.55 4.5-.55s.01 1.52-.8 2.53c-.61.76-.96 1.05-1.01 1.95s.54 1.82.54 1.82s-1.28-.52-3.57.71c-1.35.73-2.32 2.76-5.76 2.85c-2.85.08-3.48-1.01-6.9-1.71c-2.09-.43-3.23.57-3.23.57s1.62-2.41 1.38-3.74c-.24-1.33-2.12-2.12-2.36-3.07c1.19-.48 2.31-.57 4.6-.42c3.71.24 2.94 1.67 6.66 1.72z",
    fill: "#367c2d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8 49.47l-1.18-2.46s1.46 0 2.78-.82c1.32-.82 2.46-2.14 4.69-1.82s3.87 4.14 9.33 4.14c4.55 0 4.92-3.28 9.65-3.23c5.04.05 6.42 2.69 6.42 2.69s-.88 1.69-.83 3.06s1.33 3.7 1.33 3.7s-3.55-1.34-6.05-1.25c-2.5.09-5.92 3.87-10.88 3.51c-5.06-.37-6.1-3.64-9.74-4.55c-3.64-.91-4.64.05-4.64.05l-.88-3.02z",
    fill: "#367c2d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.63 64.09c3.46.09 3.91 2.39 7.19 2.2c3.28-.18 3.8-2.33 7.85-2.24s5.45 2.43 8.04 2.68c2.95.28 4.5-.44 4.5-.44s.01.8-1.22 2.44s-3.64 3.73-3.64 3.73l-19.67.36l-3.05-8.73z",
    fill: "#367c2d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.28 83.22s3.99 10.61 10.03 11.68c6.04 1.07 9.96 1.06 13.95.08c3.99-.97 6.1-4.76 5.71-8.55s-5.06-6.42-6.91-8.37s-7.01-9.73-14.5-10.71c-7.89-1.02-13.53 5.35-13.53 5.35l5.25 10.52z",
    fill: "#484e27"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.51 69.01s-5.16-.49-8.08 1.85s-3.7 5.84-6.42 7.59c-2.73 1.75-5.36 1.46-7.4 4.19c-1.93 2.58-1.69 6.5-.35 8.76c1.8 3.05 3.74 3.51 7.71 3.82c3.79.3 9.87.37 9.87.37l4.67-26.58z",
    fill: "#484e27"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.12 62.67l-9.68 36.71l6.48.21s5.06-.44 8.23-.79c3.17-.35 8.17-1.16 8.17-1.16l5.9-11.29l-19.1-23.68z",
    fill: "#2f2f2f"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.41 94.89L14 93.66s.79-3.52 4.23-12.59s7.75-19.72 9.33-23.06c1.58-3.35 2.99-7.92 3.7-8.45c.7-.53 9.15-1.06 18.49-1.32s26.14.09 26.67.35c.53.26-.53 7.75-.53 7.75L60.22 99.65l-29.75-2.82l-15.06-1.94z",
    fill: "#f19f40"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab6009",
    cx: 90.044,
    cy: 101.269,
    r: 30.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    stopColor: "#f3ae3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f2a53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#f08c38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976,
    stopColor: "#ec6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec5f32"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.34 101.66s3.85.09 7.73-.17c3.87-.26 13.24-1.01 13.86-1.54c.62-.53.31-10.61.67-18.27c.35-7.66.49-14.35.92-15.45c.33-.84 11.84 32.09 11.84 32.09l13.82-2.46s-8.12-15.69-11.99-22.47s-13.17-24.94-14.71-24.9c-1.1.02-9.42 18.69-11.87 24.5c-2.95 6.98-5.89 14.93-7.91 20.6c-1.61 4.5-2.36 8.07-2.36 8.07z",
    fill: "url(#IconifyId17ecdb2904d178eab6009)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.18 97.29c-.08 1.93-.34 4.13-1.24 4.68c-.89.55-18.56-1.99-25.84-2.89c-7.7-.95-17.17-3.07-17.59-3.55c-.41-.48-.05-3.3.64-3.99c.69-.69.84 1.62.84 1.62s11.14 2.2 16.11 2.72c7.84.83 20.64 2.54 22.09 2.13c1.44-.41 2.22-4.59 3.5-4.41c1.28.18 1.56 2.1 1.49 3.69z",
    fill: "#9c2d1b"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7 65.81c-.21-.44-.55.79.08 3.7c.54 2.48 9.83 29.22 9.97 29.43c.14.21 4.19-.21 4.19-.21l8.32-3.09l-9.9-8.87l-7.08-11c0-.01-5.43-9.62-5.58-9.96z",
    fill: "#9c2d1b"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M100.38 98.19s-7.29-5.98-8.99-7.92c-5.1-5.8-7.91-11.96-8.53-13.06c-.62-1.1-4.97-10.06-5.18-10.68c-.21-.62 0-1.38.62-.41c.62.96 3.48 6.46 5.86 10.2c.58.9 5.48 8.06 6.74 9.42c5.32 5.75 10.93 9.42 10.93 9.42l-1.45 3.03z",
    fill: "#ea4133"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3 105.95l-.96 2.54s-.14 1.31.07 1.58c.21.28 12.51-.07 12.51-.07s-.14 1.93.41 2.41c.55.48 7.22.41 7.49.07c.28-.34.34-2.75.34-2.75s3.99.21 4.4.07c.41-.14 0-3.51 0-3.51l-4.47-3.37l-19.79 3.03z",
    fill: "#a05c3c"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.75 100.66l-.41 7.84l12.45-.28s.07-2.75.28-2.89c.49-.33 7.84-.83 8.18-.41c.34.41.21 3.16.21 3.16l4.26-.21s0-5.36-.21-5.5c-.21-.14-18.15-1.51-19.87-1.58c-1.73-.07-4.96-.62-4.89-.13z",
    fill: "#c67c5d"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab6010",
    cx: 99.181,
    cy: 105.546,
    r: 16.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149,
    stopColor: "#fdf4df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "#fadd9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#f7cb6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#f6c14b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#f5bd40"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M104.94 81.4s-3.62 5.95-8.32 9.97c-2.61 2.23-4.68 5.02-4.47 8.73c.16 2.86 2.89 5.18 6.94 5.36c9.14.41 10.45-5.02 10.93-8.25c.48-3.23.05-10.99-.07-11.21c-.31-.57-1.81 2.39-3.09 3.85c-1.44 1.65-3.23 3.03-3.23 3.03s1.62-4.18 1.87-7.01c.24-2.67.12-4.81-.56-4.47z",
    fill: "url(#IconifyId17ecdb2904d178eab6010)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M63.84 15.34c-1.21-.89-3.05-.64-3.92.77c-.87 1.41-.54 3.31.92 4.02c1.46.7 2.72.24 3.48-.73s1.06-2.93-.48-4.06z",
    fill: "#ffffff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M70.02 14.19c-.83.86-.67 2.07.06 2.77c.73.7 2.07.42 2.58-.1c.73-.73.77-2.14 0-2.81c-.61-.53-1.71-.82-2.64.14z",
    opacity: 0.56,
    fill: "#ffffff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M43.82 4.25c-1.59-.1-2.55 1.47-2.49 2.58c.06 1.12.76 2.52 2.71 2.55c2.26.03 2.52-2.3 2.33-3.16c-.12-.52-.51-1.84-2.55-1.97z",
    fill: "#ffffff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02 44.09c.48 1.26 2 2.15 3.6 1.35c1.58-.79 1.62-2.51.96-3.73c-.66-1.22-2.41-1.29-3.37-.83c-.96.47-1.72 1.82-1.19 3.21z",
    fill: "#ffffff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M111.27 24.58c-.86 1.27-.89 2.87.16 3.79c1.05.92 2.99.83 4.01-.57c.96-1.31.73-2.83-.25-3.79s-3.06-.7-3.92.57z",
    fill: "#ffffff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M97.95 5.23c-.81.86-1.12 2.43-.03 3.38c.92.8 2.45.61 3.18-.35s.45-2.42-.19-3.09c-.63-.68-2.03-.93-2.96.06z",
    fill: "#ffffff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M29.67 25.15s1.18-3.63 1.83-3.75c.65-.12 2.08 3.75 2.08 3.75s3.06.16 3.3.82c.24.65-2.28 2.61-2.28 2.61s.98 3.38.57 3.71c-.41.33-3.71-1.75-3.71-1.75s-2.73 2.61-3.5 2.2c-.77-.41.57-4.08.57-4.08s-2.65-1.71-2.69-2.65s3.83-.86 3.83-.86z",
    fill: "#ffffff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamping);
export default __webpack_public_path__ + "static/media/camping.2b700a37109e59da497f5e85660ec49b.svg";
export { ForwardRef as ReactComponent };